import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import './polyfills/url-canParse';
import { Amplify } from 'aws-amplify';
import awsConfig from "./awsconfig";

import {
  fetchAuthSession,
  getCurrentUser
} from 'aws-amplify/auth';

import TheErrorLayout from './containers/TheErrorLayout';
import { page } from './constants/page';
import { Helmet } from "react-helmet";
import favicon from './assets/images/favicon.ico';

Amplify.configure(awsConfig);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Mfa = React.lazy(() => import('./views/pages/mfa/Mfa'));
const CompleteNewPassword = React.lazy(() => import('./views/pages/login/CompleteNewPassword'));
const Logout = React.lazy(() => import('./views/pages/logout/Logout'));
// const Register = React.lazy(() => import('./views/pages/register/Register'));
const Reset = React.lazy(() => import('./views/pages/reset/Reset'));
const ForgotPasswordVerification = React.lazy(() => import('./views/pages/reset/ForgotPasswordVerification'));
// const ChangePassword = React.lazy(() => import('./views/pages/change-password/ChangePassword'));

class App extends Component {
  // mod@ccs start ---
  state = {
    isAuthenticated: false,
    isAuthenticating: true,
    user: null,
  }

  setAuthStatus = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  setUser = user => {
    this.setState({ user: user});
  }
  setAuthStatusAndUser = (authenticated,user) => {
    this.setState({ isAuthenticated: authenticated, user: user });
  };
  async componentDidMount() {
     try{
      await fetchAuthSession()
      const user = await getCurrentUser();
      this.setAuthStatusAndUser(true, user);
    } catch (error) {
      this.setAuthStatusAndUser(false, null);
    }

    this.setState({ isAuthenticating: false });
  }

  //mod@ccs end ---
   
  render() {
    // mod@ccs ---
    const authProps = {
      isAuthenticated : this.state.isAuthenticated,
      user: this.state.user,
      setAuthStatus: this.setAuthStatus,
      setUser: this.setUser,
      setAuthStatusAndUser:this.setAuthStatusAndUser
    };
    // mod@ccs ---
    return (
      // mod@ccs start ---
      !this.state.isAuthenticating && 
        // mod@ccs end ---
      <HashRouter>
          <Helmet>
            <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
          </Helmet>
          <React.Suspense fallback={loading}>
            <Switch>
              {/* <Route exact path="/login" name="Login Page" render={props => <Login {...props} auth={authProps}/>} /> */}
              <Route
                  exact
                  path="/login"
                  name="Login Page"
                  render={(props) =>
                  {                       
                    return window.location.host === process.env.REACT_APP_DOMAIN ?(
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <TheLayout {...props} auth={authProps} />
                    ) : page.some((item) => window.location.href.includes(item)) ||
                      !window.location.host.includes(process.env.REACT_APP_DOMAIN) ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Login {...props} auth={authProps} />
                    )
                  }
                  }
                />
                <Route
                  exact
                  path="/mfa"
                  name="Mfa page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Mfa {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/completeNewPassword"
                  name="CompleteNewPassword Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <CompleteNewPassword {...props} auth={authProps} />
                    )
                  }
                />
              {/* <Route exact path="/logout" name="Logout Page" render={props => <Logout {...props} auth={authProps}/>} /> */}
              <Route
                  exact
                  path="/logout"
                  name="Logout Page"
                  render={(props) =>
                   {
                    return  window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <Logout {...props} auth={authProps} />
                    ) : (
                      <TheLayout {...props} auth={authProps} />
                    )
                   }
                  }
                />

              {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props} auth={authProps}/> }/> */}
              <Route
                  exact
                  path="/reset"
                  name="Reset Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Reset {...props} auth={authProps} />
                    )
                  }
                />
                <Route
                  exact
                  path="/forgotPasswordVerification"
                  name="ForgotPasswordVerification Page"
                  render={(props) =>
                    window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <ForgotPasswordVerification {...props} auth={authProps} />
                    )
                  }
                />
              {/* <Route exact path="/changePassword" name="ChangePassword Page" render={props => <ChangePassword {...props} auth={authProps}/>} /> */}
              {/* <Route exact path="/changePassword" name="ChangePassword Page" render={props => this.state.isAuthenticated ? <ChangePassword {...props} auth={authProps}/> : <TheLayout {...props} auth={authProps} />} /> */}
              <Route
                  path="/"
                  name="Home"
                  render={(props) =>
                  { 
                    return window.location.host === process.env.REACT_APP_DOMAIN ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : this.state.isAuthenticated ? (
                      <TheLayout {...props} auth={authProps} />
                    ) : page.some((item) => window.location.href.includes(item)) ||
                      !window.location.host.includes(process.env.REACT_APP_DOMAIN) ? (
                      <TheErrorLayout {...props} auth={authProps} />
                    ) : (
                      <Login {...props} auth={authProps} />
                    )
                  }
                  }
                />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}
export default App;
//export default withAuthenticator(App);